"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = exports.factory = exports.constants = void 0;
const constants_1 = __importDefault(require("./constants"));
const ToolsOperationsFactory_1 = require("./ToolsOperationsFactory");
const operationsFromDocument_1 = require("./converter/operationsFromDocument");
const operationsToDocument_1 = require("./converter/operationsToDocument");
const operationsFromDocumentInst = new operationsFromDocument_1.OperationsFromDocumentConverter();
const operationsToDocumentInst = new operationsToDocument_1.OperationsToDocumentConverter();
exports.constants = constants_1.default;
exports.factory = new ToolsOperationsFactory_1.ToolsOperationsFactory();
exports.converter = {
    operationsFromDocument: (document, options = {}) => operationsFromDocumentInst.convert(document, options),
    operationsToDocument: (operations, options) => operationsToDocumentInst.convert(operations, options),
};
//# sourceMappingURL=index.js.map